<template>
    <div>
        <div :id="id" :style="'height:' + height"></div>

        <slot name="input" />
    </div>
</template>

<script>
    export default {
        name: "GoogleMapGeoInput",

        props: {
            id: {
                type: String,
                default: 'map'
            },
            height: {
                type: String,
                default: '350px'
            },
            draggable: {
                type: Boolean,
                default: false
            },
            latValue: {
                type: String
            },
            lngValue: {
                type: String
            },
            latInputId: {
                type: String
            },
            lngInputId: {
                type: String
            },
        },

        data() {
            return {
                map: null,
                mapZoom: 18,
                markerLat: null,
                markerLng: null,
                marker: null
            }
        },

        mounted() {
            this.map = new google.maps.Map(document.getElementById(this.id), {
                zoom: this.mapZoom
            })

            this.initMarker()
        },

         created () {
            var that = this
            this.emitter.on('addMarker', function (e) {
                that.updateMarker(e.lat, e.lng, e.title)
            })
        },

        methods: {
            initMarker() {
                if (this.lngValue && this.latValue) {
                    this.addMarker(this.latValue, this.lngValue)
                } else {
                    if (navigator.geolocation) {
                        let that = this
                        navigator.geolocation.getCurrentPosition(function(position) {
                            that.addMarker(position.coords.latitude, position.coords.longitude, 18)
                        }, function() {
                            that.getLocationFromIpInfo()
                        });
                    } else {
                        this.getLocationFromIpInfo()
                    }
                }
            },
            setGeo(lat, lng) {
                return {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng)
                }
            },
            addMarker (lat, lng, zoom = 2, title = "") {
                let pos = this.setGeo(lat, lng)

                let icon = {
                    url: '/assets/img/maker.svg',
                    scaledSize: new google.maps.Size(40, 40),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 0)
                }

                this.map.setCenter(pos)
                this.map.setZoom(zoom)

                let marker = new google.maps.Marker({
                    position: pos,
                    map: this.map,
                    title: title,
                    animation: google.maps.Animation.BOUNCE,
                    icon: icon,
                    draggable: this.draggable,
                });

                marker.addListener("click", function() {
                    marker.setAnimation(null)
                })

                if (this.draggable) {
                    let that = this
                    google.maps.event.addListener(marker, 'dragend', function(){
                        let lat = marker.getPosition().lat();
                        let lng = marker.getPosition().lng()
                        let pos = that.setGeo(lat, lng)

                        that.changeInputValue(pos)
                    });
                }

                this.marker = marker

                if (this.draggable) {
                    this.changeInputValue(pos)
                }
            },

            updateMarker(lat, lng, title) {
                let pos = this.setGeo(lat, lng)

                this.map.setCenter(pos)
                this.map.setZoom(4)

                this.marker.setTitle(title)
                this.marker.setPosition(pos)

                this.changeInputValue(pos)
            },
            
            getLocationFromIpInfo () {
                fetch('https://ipinfo.io/json')
                    .then(res => res.json())
                    .then(resp => {
                        let res = resp.loc.split(",");
                        return this.addMarker(parseFloat(res[0]), parseFloat(res[1]), 13)
                    }).catch(error => {
                        return this.addMarker(parseFloat('5.362587'), parseFloat('-3.946801'), 13)
                    })
            },
            changeInputValue(pos) {
                this.$emit('mapValueChanged', {id: this.id, pos})
            }
        }
    }
</script>